// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {LottieEl} from '../lottie';
import {SvgIconEl} from '../svg-icon';
import type {Spinner} from './index';
import {SpinnerColor, SpinnerSize, SpinnerTheme} from './types';
import limitedSegLottie from './limited-seg.lottie';

export function template(this: Spinner) {
  const showCustomSpinner = this.attr(`theme`) !== SpinnerTheme.Default;
  let spinnerClass: Record<string, boolean> = {
    'mp-spinner': true,
    'mp-spinner-blue': this.attr(`color`) === SpinnerColor.Blue,
    'mp-spinner-white': this.attr(`color`) === SpinnerColor.White,
    'mp-spinner-inherit-color': this.attr(`color`) === SpinnerColor.Inherit,
  };
  if (showCustomSpinner) {
    spinnerClass = {
      'custom-spinner': true,
      [this.attr(`theme`)]: true,
    };
  }

  return (
    <div
      class={{
        ...spinnerClass,
        'large-spinner': this.attr(`size`) === SpinnerSize.Large,
        'medium-spinner': this.attr(`size`) === SpinnerSize.Medium,
      }}
    >
      {!showCustomSpinner ? <SvgIconEl attrs={{icon: `spinner`}} /> : null}
      {this.attr(`theme`) === SpinnerTheme.Fancy && (
        <LottieEl
          attrs={{
            config: {path: limitedSegLottie},
          }}
        />
      )}
    </div>
  );
}
